<template>
  <table class="table">
    <thead class="table-head">
    <tr>
      <th title="Filter op: Onderwerp">Onderwerp</th>
      <th title="Filter op: Periode">Periode</th>
      <th title="Filter op: Behandelaar">Behandelaar</th>
      <th title="Filter op: Status">Status</th>
    </tr>
    </thead>
    <tbody class="table-body">
    <tr>
      <td title="Filter op: Onderwerp">
        <a-input
            v-model="filter.childName"
            :allow-clear="true"
            @input="triggerFilter"
            placeholder="Onderwerp..."
            v-on:click.stop
        ></a-input>
      </td>
      <td title="Filter op: Periode">
        <a-range-picker
            :default-picker-value="[moment().subtract(1, 'months'), moment()]"
            :placeholder="['Startdatum', 'Einddatum']"
            :ranges="{
            'Vorige maand': [
              moment().subtract(1, 'months').startOf('month'),
              moment().subtract(1, 'months').endOf('month')
            ],
            'Deze maand': [
              moment().startOf('month'),
              moment().endOf('month')
            ],
          }"
            format="DD/MM/YYYY"
            style="max-width: 200px"
            @change="setFilterDateRange">
          <a-icon slot="suffixIcon" type="calendar"/>
        </a-range-picker>
      </td>
      <td title="Filter op: Behandelaar">
        <users-select
            appendCssClass="small"
            style="display: inline-block; min-width: 160px;"
            @change="setFilterCreatedByUser"
        />
      </td>
      <td title="Filter op: Status">
        <a-select
            v-model="filter.visibleForCustomer"
            style="min-width: 135px;"
            v-on:change="triggerFilter"
            v-on:click.stop
        >
          <a-select-option :value="null">
            Alle
          </a-select-option>
          <a-select-option value="0">
            Niet gepubliceerd
          </a-select-option>
          <a-select-option value="1">
            Gepubliceerd
          </a-select-option>
        </a-select>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/nl_NL';
import moment from 'moment';

export default {
  name: "NoteOverviewFilterComponent",
  props: {
    customerId: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  data() {
    return {
      locale,
      filter: {
        childName: null,
        dateRange: [],
        createdByUser: null,
        visibleForCustomer: null,
      },
    }
  },
  methods: {
    moment,
    triggerFilter() {
      this.filterRequest();
    },
    setFilterDateRange(date) {
      this.filter.dateRange = [];
      if (date.length) {
        this.filter.dateRange[0] = date[0].startOf('day').format('YYYY-MM-DD HH:mm:ss');
        this.filter.dateRange[1] = date[1].endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
      this.filterRequest();
    },
    setFilterCreatedByUser(value) {
      Object.assign(this.filter.createdByUser = value);
      this.filterRequest();
    },
    filterRequest() {
      this.$emit('filter-request', this.filter);
    }
  },
}
</script>

<style scoped>
.table-head > tr > th {
  background-color: transparent;
}

.table-body > tr > td {
  border-top: 0;
}
</style>

